import type { Transport } from "mediasoup-client/types";
import { socket } from "./socket";
import { getDevice } from "./device";

 const handleTransportConnect = (
  dtlsParameters: any,
  cb: (args?: any) => void, 
) => {
  socket.emit(
    "connect-transport",
    { direction: "send", dtlsParameters },
    cb,
  );
}

const handleProduce=(data: any, cb: (args?: any) => void)=>{
  socket.emit("produce", data, ({ id }: any) => cb({ id }));


}

const createTransPort=(params: any)=>{
  const transport = getDevice().createSendTransport(params);

  transport.on("connect", ({ dtlsParameters }, cb) => {
    handleTransportConnect(dtlsParameters, cb);
  });
  transport.on("produce", (data, cb) => {
    handleProduce(data, cb);
  });

  return transport;

}


export async function createSendTransport(): Promise<Transport> {
  return new Promise((resolve) => {
    socket.emit("create-transport", { direction: "send" }, (params: any) => {
      const transport = createTransPort(params);
      resolve(transport);
    });
  });
}
